<div class="sh-detail-list-layout">
  <section class="sh-detail-list-layout__list">
    <div class="sh-detail-list-layout__list__head">
      <div class="sh-page-section sh-page-section--vertical--narrow">
        <ng-container *ngTemplateOutlet="topContent"></ng-container>
      </div>
    </div>
    <div class="sh-detail-list-layout__list__content">
      @if (filtersContent) {
        <div class="sh-detail-list-layout__list__content__filters" [class.sticky-filters]="embedded">
          <div id="filters" class="sh-filters" [class.-sh-collapsed]="filtersCollapsed">
            <div class="sh-filters__collapse-handle">
              <button type="button" (click)="onToggleFilters($event)" class="sh-pure-icon-button -sh-raised" aria-label="angle-double-left">
                <svg sh-icon [name]="'angle-double-left'" [size]="IconSize.SMALL" aria-hidden="true" class="sh-icon-button__icon"></svg>
              </button>
            </div>
            <div class="sh-filters__content">
              <div class="sh-page-section--horizontal sh-page-section--vertical--end">
                <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
              </div>
            </div>
            <div class="sh-filters__content--collapsed">
              <div class="sh-page-section--horizontal">
                <ng-container *ngTemplateOutlet="filtersCollapsedContent"></ng-container>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="sh-detail-list-layout__list__content__list">
        <div class="sh-page-section--horizontal sh-page-section--vertical--end">
          <ng-container *ngTemplateOutlet="mainContent"></ng-container>
        </div>
      </div>
    </div>
  </section>
  @if (detailContent) {
    <section id="detail" class="sh-detail-list-layout__detail sh-scroll-container" [class.-sh-collapsed]="detailsCollapsed">
      <div>
        <ng-container *ngTemplateOutlet="detailContent"></ng-container>
      </div>
    </section>
  }
</div>
